import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings";

const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const H2 = tw.h2`tracking-wide font-medium text-primary-700`; 
const Article = tw.p`text-sm p-3 rounded-[10px] border border-gray-500 bg-[#f0fff0]`

function MentionsLegales() {
  return (
  <main id="main" tw="flex flex-col gap-6 text-gray-700 px-16 mb-12">
	<section>
        <SectionHeading><span tw="text-secondary-500">Mentions</span> <HighlightedText>Légales</HighlightedText></SectionHeading>



		<h5 tw="text-center">En vigueur au
			01/01/2020</h5>

	</section>
	<section tw="flex flex-col gap-5">

		<p>Conformément aux dispositions des Articles 6-III et 19 de la Loi
			n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie
			numérique, dite L.C.E.N., il est porté à la connaissance des
			Utilisateurs du site <em>IMPOTS-REDUC.FR&nbsp;</em>les présentes
			mentions légales.</p>
		<p><span>La connexion et la navigation sur
				le site IMPOTS-REDUC.FR par l’Utilisateur implique
				acceptation intégrale et sans réserve des présentes mentions
				légales.</span></p>
		<p>Ces dernières sont accessibles sur le site à la rubrique
			«&nbsp;Mentions légales&nbsp;».</p>


		<H2>ARTICLE 1 :
			L’éditeur</H2>



		<Article>L’édition et la direction de la publication du site
			IMPOTS-REDUC.FR&nbsp;est assurée par Abdelwahid DJABALLAH,
			représentant légal de la société SASU LEADS AND CO –
			Siren&nbsp;: 889460374 – domiciliée au 23 RUE CREPET, 69007
			LYON, dont le&nbsp;numéro de téléphone est le <a href="tel:+33988290770">09 88 29 07 70</a>, et l’adresse
			e-mail est <a href="mailto:contact@impots-reduc.fr">contact@impots-reduc.fr</a>.
		</Article>


		<H2>ARTICLE 2 :
			L’hébergeur</H2>



		<Article>L’hébergeur du site IMPOTS-REDUC.FR&nbsp;est la Société OVH, dont
			le siège social est situé au 2 rue Kellermann, 59100 Roubaix,
			avec le numéro de téléphone : 1070.</Article>


		<H2>ARTICLE 3 :
			Accès au site</H2>



		<Article>Le site est accessible par tout endroit, 7j/7, 24h/24 sauf cas de
			force majeure, interruption programmée ou non et pouvant
			découler d’une nécessité de maintenance.
		<br />En cas de modification, interruption ou suspension des services,
			le site <em>IMPOTS-REDUC.FR&nbsp;</em>ne saurait être tenu
			responsable.</Article>

		<H2>ARTICLE 4 :
			Collecte des données</H2>



		<Article>Le site assure à l’Utilisateur une collecte et un traitement
			d’informations personnelles dans le respect de la vie privée
			conformément à la loi n°78-17 du 6 janvier 1978 relative à
			l’informatique, aux fichiers et aux libertés. Le site est soumis
			à la Réglementation générale sur la protection des données aux
			nouvelles dispositions européennes relatives à la RGDP en
			vigueur depuis le 25 mai 2018.<br /><br />
            Les données personnelles collectées sur le site et/ou par
			téléphone sont transmises exclusivement aux Partenaires
			d’IMPOTS-REDUC.FR, dans le cadre de sa mission de mise en
			relation gratuite et sans engagement.</Article>



		<p tw="text-sm"><strong><u>Dans le cadre de notre charte Qualité&nbsp;:</u> comme
				convenu avec l’Utilisateur, ses données personnelles qui ont
				été collectées par voie électronique, postale ou par
				téléphone, sont transmises à 1 Partenaire du site
				IMPOTS-REDUC.FR, et ce de façon exclusive. Le Partenaire du
				site IMPOTS-REDUC.FR n’a en aucun cas le droit de
				transmettre les données personnelles de l’Utilisateur à un
				tiers, sauf s’il obtient l’accord express de l’Utilisateur.
				Cette mise en relation est faite d’un commun accord avec
				l’Utilisateur, exprimé par un support numérique ou par
				téléphone.</strong></p>
		<p tw="text-sm"><strong>En vertu de la loi Informatique et Libertés, en date du 6
				janvier 1978, l’Utilisateur dispose d’un droit d’accès, de
				rectification, de suppression et d’opposition de ses données
				personnelles. L’Utilisateur exerce ce droit par e-mail, qui
				doit porter la mention «&nbsp;Données personnelles&nbsp;» à
				l’adresse suivante&nbsp;: <a
					href="mailto:contact@impots-reduc.fr"><u>contact@impots-reduc.fr</u></a></strong>
		</p>


		<H2>ARTICLE 5 :
			Cookies</H2>



		<Article>L’Utilisateur est informé que lors de ses visites sur le site, un
			cookie peut s’installer automatiquement sur son logiciel de
			navigation.
		En naviguant sur le site, il les accepte.<br /><br />
		Un cookie est un élément qui ne permet pas d’identifier<br /><br />
			l’Utilisateur mais sert à enregistrer des informations relatives
			à la navigation de celui-ci sur le site Internet. L’Utilisateur
			pourra désactiver ce cookie par l’intermédiaire des paramètres
			figurant au sein de son logiciel de navigation.</Article>


		<H2>ARTICLE 6 :
			Propriété intellectuelle</H2>


		<Article>Toute utilisation, reproduction, diffusion, commercialisation,
			modification de toute ou partie du site
			<em>IMPOTS-REDUC.FR</em>,&nbsp;sans autorisation de l’Editeur
			est prohibée et pourra entraîner des actions et poursuites
			judiciaires telles que notamment prévues par le Code de la
			propriété intellectuelle et le Code civil.
		</Article>

	</section>

</main>
  )
}
export default MentionsLegales